import { render, staticRenderFns } from "./verification-email.vue?vue&type=template&id=309e2ae2&"
import script from "./verification-email.vue?vue&type=script&lang=js&"
export * from "./verification-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports